import React from 'react';
import { ReturnableReturnPolicy } from './ShortReturnPolicyCopy';
import { getReturnPolicy } from './getReturnPolicy';

interface Props {
  returnPolicy: ReturnableReturnPolicy;
  promoCodeApplied: boolean;
}

export const LongReturnPolicyCopy: React.FC<Props> = ({ returnPolicy, promoCodeApplied }) => {
  const { returnDaysNumber } = getReturnPolicy(returnPolicy, promoCodeApplied);

  return (
    <>
      {`This item is returnable for a full refund within ${returnDaysNumber} days from the date that
      the order was delivered to you.`}
    </>
  );
};
